/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'hammerjs'
],
function(BaseClass, Hammer) {

	var SwipeGesture = BaseClass.extend([], {
		/**
			 * Constructor
			 * This class implementation is still in progess. Should move out to common component at a later time
			 *
			 * @param {object} args - arguments
			 *
			 * @constructs Swipe
			 * @extends {lib/@waca/core-client/js/core-client/ui/core/Class}
			 */
		init: function(options) {
			SwipeGesture.inherited('init', this, arguments);

			this.$el = options.$el;
			this.handlers = options.handlers;
			this.direction = options.direction ? options.direction : Hammer.DIRECTION_HORIZONTAL;
			this.panes = options.items.get();
			this.chevronStates = this.handlers.updateLeftRightActiveState();
			this.tranformPos = 0;
			this.deltaX = options.scrollDistance;
			if (!this.deltaX) {
				this.deltaX = this.panes.length ? this.$el.width() / this.panes.length : 100;
			}

			var thisInst = this;
			var fnSwipe = function() {};
			var data = {
				type: 'swipe',
				handlers: [{
					name: 'swipeleft',
					handler: function(event) {
						if (this.chevronStates.rightActive) {
							this._onSwipeLeftRight(event, true);
						}
					}.bind(thisInst)
				},
				{
					name: 'swiperight',
					handler: function(event) {
						if (this.chevronStates.leftActive) {
							this._onSwipeLeftRight(event, false);
						}
					}.bind(thisInst)
				}
				]
			};
			this.$el.on('swipe', undefined, data, fnSwipe);
		},

		destroy: function() {
			this.$el.off('swipe');
		},

		_onSwipeLeftRight: function(event, swipeLeft) {
			var scrollLeftPos = this.$el.scrollLeft();
			var scrollToPos = scrollLeftPos + (swipeLeft ? this.deltaX : -this.deltaX);
			this.tranformPos = this.tranformPos + (swipeLeft ? -this.deltaX : this.deltaX);

			//Ensure not scroll pass scrollWidth
			if (swipeLeft) {
				if (Math.abs(this.tranformPos) >= this.$el.width() - this.deltaX) {
					scrollToPos = this.$el.width() - this.deltaX;
					this.tranformPos = -(this.$el.width() - this.deltaX);
					this.chevronStates.rightActive = false;
				}
			} else if (scrollToPos <= 0) { //Ensure not scroll pass 0
				this.tranformPos = 0;
				this.chevronStates.leftActive = false;
			}

			var index, translate;
			for (index = 0; index < this.panes.length; index++) {
				if (this.direction === Hammer.DIRECTION_HORIZONTAL) {
					translate = 'translate3d(' + this.tranformPos + 'px, 0, 0)';
				} else {
					translate = 'translate3d(0, ' + this.tranformPos + 'px, 0)';
				}

				this.panes[index].style.transform = translate;
				this.panes[index].style.mozTransform = translate;
				this.panes[index].style.webkitTransform = translate;
			}

			this.$el.animate({
				scrollLeft: scrollToPos
			}, 300, function() {
				this.handlers.enableChevron(false, this.chevronStates.rightActive);
				if (swipeLeft) {
					if (!this.chevronStates.leftActive) {
						this.chevronStates.leftActive = true;
						this.handlers.enableChevron(true, this.chevronStates.leftActive);
					}
				} else {
					this.handlers.enableChevron(true, this.chevronStates.leftActive);
					if (!this.chevronStates.rightActive) {
						this.chevronStates.rightActive = true;
						this.handlers.enableChevron(false, this.chevronStates.rightActive);
					}
				}
			}.bind(this));
		}
	});

	return SwipeGesture;
});
